import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import loader from "../../Images/ajax-loader.gif";
import {
  getCleanlinessInspection,
  saveCleanlinessInspection,
  updateCleanlinessInspection
} from "../../api/User";

const translations = {
  en: {
    back: "Back",
    title: "Cleanliness, Solid Waste Management, Inspection of Government Building",
    langToggle: "हिन्दी",
    q1: "1. Are all public places clean?",
    yes: "Yes",
    no: "No",
    q2: "2. Is door-to-door collection of solid waste being carried out regularly?",
    q3: "3. Is 4-way source segregation (Wet Waste, Dry Waste, Sanitary Waste, Special Care Waste) being practiced?",
    q4: "4. Is a Solid Waste management shed (SWM Shed) available in the Gram Panchayat?",
    q5: "5. Are public dustbins available and properly maintained?",
    q6: "6. Are public/community toilets (Community Sanitary Complexes) functional, clean, and being regularly maintained?",
    q7: "7. Is there any gap in infrastructure related to solid waste management and requires action?",
    infrastructureGapSpecify: "If yes, please specify",
    q8: "8. Have awareness activities on cleanliness been conducted in the village?",
    q9: "9. Overall Status of Cleanliness & Solid Waste Management",
    good: "Good",
    satisfactory: "Satisfactory",
    needsImprovement: "Needs Improvement",
    q10: "10. Total Number of Government Buildings in the Gram Panchayat",
    q11: "11. Total Number of Government Buildings in Good Condition",
    q12: "12. Total Number of Government Buildings in satisfactory Condition",
    q13: "13. Total Number of Government Buildings Requiring Repair/Maintenance",
    q14: "14. Are all Government Buildings being utilized for their intended purpose?",
    selectOption: "Select",
    cancel: "Cancel",
    save: "Save",
    update: "Update",
    saving: "Saving...",
    validationError: "Please resolve the validation errors in the form.",
    infrastructureGapError: "Please specify details for the infrastructure gap",
    govBuildingsTotalError: "Total number of government buildings is required",
    govBuildingsGoodError: "Number of buildings in good condition is required",
    govBuildingsSatisfactoryError: "Number of buildings in satisfactory condition is required",
    govBuildingsRepairRequiredError: "Number of buildings requiring repair/maintenance is required",
    confirmTitle: "Confirm Save",
    confirmMsgSave: "After saving you will allow only edit once. Do you want to proceed?",
    confirmMsgUpdate: "You will not be allowed to edit this form after saving. Do you want to proceed?",
    okay: "Okay",
  },
  hi: {
    back: "पीछे",
    title: "स्वच्छता, ठोस कचरा प्रबंधन, सरकारी भवनों का निरीक्षण",
    langToggle: "English",
    q1: "1. क्या सभी सार्वजनिक स्थान साफ हैं?",
    yes: "हाँ",
    no: "नहीं",
    q2: "2. क्या कचरे का घर-घर संग्रहण नियमित रूप से किया जा रहा है?",
    q3: "3. क्या 4-स्तरीय कचरा पृथक्करण (गीला कचरा, सूखा कचरा, सैनिटरी कचरा, विशेष कचरा) किया जा रहा है?",
    q4: "4. क्या ग्राम पंचायत में ठोस कचरा प्रबंधन शेड (SWM शेड) उपलब्ध है?",
    q5: "5. क्या सार्वजनिक डस्टबिन उपलब्ध हैं और उनका ठीक से रखरखाव किया जा रहा है?",
    q6: "6. क्या सार्वजनिक/सामुदायिक शौचालय कार्यात्मक, साफ और नियमित रूप से अनुरक्षित हैं?",
    q7: "7. क्या ठोस कचरा प्रबंधन से संबंधित बुनियादी ढांचे में कोई कमी है और कार्रवाई की आवश्यकता है?",
    infrastructureGapSpecify: "यदि हाँ, तो कृपया स्पष्ट करें",
    q8: "8. क्या गाँव में स्वच्छता पर जागरूकता गतिविधियाँ आयोजित की गई हैं?",
    q9: "9. स्वच्छता और ठोस कचरा प्रबंधन की समग्र स्थिति",
    good: "अच्छी",
    satisfactory: "संतोषजनक",
    needsImprovement: "सुधार की आवश्यकता है",
    q10: "10. ग्राम पंचायत में सरकारी भवनों की कुल संख्या",
    q11: "11. अच्छी स्थिति में सरकारी भवनों की संख्या",
    q12: "12. संतोषजनक स्थिति में सरकारी भवनों की संख्या",
    q13: "13. मरम्मत/रखरखाव की आवश्यकता वाले सरकारी भवनों की संख्या",
    q14: "14. क्या सभी सरकारी भवनों का उपयोग उनके इच्छित उद्देश्य के लिए किया जा रहा है?",
    selectOption: "चुनें",
    cancel: "रद्द करें",
    save: "सहेजें",
    update: "अपडेट करें",
    saving: "सहेज रहा है...",
    validationError: "कृपया फॉर्म में त्रुटियों को ठीक करें।",
    infrastructureGapError: "कृपया बुनियादी ढांचे में कमी का विवरण दर्ज करें",
    govBuildingsTotalError: "सरकारी भवनों की कुल संख्या का चयन करना आवश्यक है",
    govBuildingsGoodError: "अच्छी स्थिति वाले भवनों की संख्या का चयन करना आवश्यक है",
    govBuildingsSatisfactoryError: "संतोषजनक स्थिति वाले भवनों की संख्या का चयन करना आवश्यक है",
    govBuildingsRepairRequiredError: "मरम्मत की आवश्यकता वाले भवनों की संख्या का चयन करना आवश्यक है",
    confirmTitle: "बदलाव सहेजें",
    confirmMsgSave: "सहेजने के बाद आपको केवल एक बार एडिट करने की अनुमति होगी। क्या आप आगे बढ़ना चाहते हैं?",
    confirmMsgUpdate: "इस बार सहेजने के बाद आपको इस फॉर्म को दोबारा एडिट करने की अनुमति नहीं होगी। क्या आप आगे बढ़ना चाहते हैं?",
    okay: "ठीक है",
  }
};

const CleanlinessForm = () => {
  const { meetingId } = useParams();
  const [searchParams] = useSearchParams();
  const gpId = searchParams.get("gp");
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("user_id");

  const [lang, setLang] = useState("en"); // English default
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  // Form Fields
  const [publicPlacesClean, setPublicPlacesClean] = useState(true);
  const [doorToDoorCollection, setDoorToDoorCollection] = useState(true);
  const [sourceSegregation, setSourceSegregation] = useState(true);
  const [swmShedAvailable, setSwmShedAvailable] = useState(true);
  const [publicDustbinsAvailable, setPublicDustbinsAvailable] = useState(true);
  const [communityToiletsFunctional, setCommunityToiletsFunctional] = useState(true);
  const [infrastructureGap, setInfrastructureGap] = useState(false);
  const [infrastructureGapDetails, setInfrastructureGapDetails] = useState("");
  const [awarenessActivity, setAwarenessActivity] = useState(true);
  const [overallStatus, setOverallStatus] = useState("Satisfactory");

  // New Fields (Government Buildings)
  const [govBuildingsTotal, setGovBuildingsTotal] = useState("");
  const [govBuildingsGood, setGovBuildingsGood] = useState("");
  const [govBuildingsSatisfactory, setGovBuildingsSatisfactory] = useState("");
  const [govBuildingsRepairRequired, setGovBuildingsRepairRequired] = useState("");
  const [govBuildingsUtilized, setGovBuildingsUtilized] = useState(true);

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    const loadRecord = async () => {
      try {
        setLoading(true);
        const res = await getCleanlinessInspection(token, meetingId);
        if (res.status === "success" && res.data) {
          const data = res.data;
          setRecordId(data.id);
          setPublicPlacesClean(!!data.public_places_clean);
          setDoorToDoorCollection(!!data.door_to_door_collection);
          setSourceSegregation(!!data.source_segregation);
          setSwmShedAvailable(!!data.swm_shed_available);
          setPublicDustbinsAvailable(!!data.public_dustbins_available);
          setCommunityToiletsFunctional(!!data.community_toilets_functional);
          setInfrastructureGap(!!data.infrastructure_gap);
          setInfrastructureGapDetails(data.infrastructure_gap_details || "");
          setAwarenessActivity(!!data.awareness_activity);
          setOverallStatus(data.overall_status || "Satisfactory");

          // Load government building details
          setGovBuildingsTotal(data.gov_buildings_total !== null && data.gov_buildings_total !== undefined ? data.gov_buildings_total : "");
          setGovBuildingsGood(data.gov_buildings_good !== null && data.gov_buildings_good !== undefined ? data.gov_buildings_good : "");
          setGovBuildingsSatisfactory(data.gov_buildings_satisfactory !== null && data.gov_buildings_satisfactory !== undefined ? data.gov_buildings_satisfactory : "");
          setGovBuildingsRepairRequired(data.gov_buildings_repair_required !== null && data.gov_buildings_repair_required !== undefined ? data.gov_buildings_repair_required : "");
          setGovBuildingsUtilized(data.gov_buildings_utilized !== null && data.gov_buildings_utilized !== undefined ? !!data.gov_buildings_utilized : true);

          // Handle freeze logic
          if (data.updated_by !== null && data.updated_by !== 0) {
            setIsFrozen(true);
          }
        }
      } catch (error) {
        console.error("Error loading cleanliness inspection details:", error);
        toast.error("Failed to load existing inspection details.", { autoClose: 2000 });
      } finally {
        setLoading(false);
      }
    };

    if (meetingId) {
      loadRecord();
    }
  }, [meetingId, token]);

  useEffect(() => {
    const role = sessionStorage.getItem("role_id");
    if (["1", "3", "7", "8"].includes(role)) {
      setIsFrozen(true);
    }
  }, []);

  const isFormValid = () => {
    if (isFrozen) return false;

    // Q7 check
    if (infrastructureGap && !infrastructureGapDetails.trim()) return false;

    // Q10-13 checks (Must be selected)
    if (govBuildingsTotal === "" || govBuildingsGood === "" || govBuildingsSatisfactory === "" || govBuildingsRepairRequired === "") return false;

    return true;
  };

  const validate = () => {
    const errors = {};
    if (infrastructureGap && !infrastructureGapDetails.trim()) {
      errors.infrastructureGapDetails = translations[lang].infrastructureGapError;
    }
    if (govBuildingsTotal === "") {
      errors.govBuildingsTotal = translations[lang].govBuildingsTotalError;
    }
    if (govBuildingsGood === "") {
      errors.govBuildingsGood = translations[lang].govBuildingsGoodError;
    }
    if (govBuildingsSatisfactory === "") {
      errors.govBuildingsSatisfactory = translations[lang].govBuildingsSatisfactoryError;
    }
    if (govBuildingsRepairRequired === "") {
      errors.govBuildingsRepairRequired = translations[lang].govBuildingsRepairRequiredError;
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveClick = (e) => {
    e.preventDefault();
    if (isFrozen) return;
    if (!validate()) {
      toast.error(translations[lang].validationError, { autoClose: 2000 });
      return;
    }
    setOpenConfirm(true);
  };

  const executeSave = async () => {
    setOpenConfirm(false);
    try {
      setSaving(true);
      const payload = {
        meeting_id: parseInt(meetingId),
        gram_panchayat_id: parseInt(gpId || sessionStorage.getItem("gp_data") || 0),
        public_places_clean: publicPlacesClean,
        door_to_door_collection: doorToDoorCollection,
        source_segregation: sourceSegregation,
        swm_shed_available: swmShedAvailable,
        public_dustbins_available: publicDustbinsAvailable,
        community_toilets_functional: communityToiletsFunctional,
        infrastructure_gap: infrastructureGap,
        infrastructure_gap_details: infrastructureGap ? infrastructureGapDetails : "",
        awareness_activity: awarenessActivity,
        overall_status: overallStatus,
        remarks: "", // Remarks field removed
        gov_buildings_total: parseInt(govBuildingsTotal),
        gov_buildings_good: parseInt(govBuildingsGood),
        gov_buildings_satisfactory: parseInt(govBuildingsSatisfactory),
        gov_buildings_repair_required: parseInt(govBuildingsRepairRequired),
        gov_buildings_utilized: govBuildingsUtilized,
      };

      let res;
      if (recordId) {
        payload.updated_by = parseInt(userId);
        res = await updateCleanlinessInspection(token, recordId, payload);
      } else {
        payload.created_by = parseInt(userId);
        res = await saveCleanlinessInspection(token, payload);
      }

      if (res.status === "success") {
        toast.success(res.message || "Saved successfully!", { autoClose: 1500 });
        setTimeout(() => {
          navigate("/gram-sabha-inspection");
        }, 1500);
      } else {
        toast.error(res.message || "Failed to save form record.");
      }
    } catch (error) {
      console.error("Error saving form:", error);
      toast.error("An error occurred while saving the form.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <img src={loader} alt="loading..." />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px", width: "100%" }}>
      <ToastContainer />

      {/* Confirmation Modal */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title" style={{ fontWeight: "bold" }}>
          {translations[lang].confirmTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description" style={{ color: "#333" }}>
            {recordId ? translations[lang].confirmMsgUpdate : translations[lang].confirmMsgSave}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: "15px 24px" }}>
          <Button 
            onClick={() => setOpenConfirm(false)} 
            variant="outlined" 
            style={{ textTransform: "none", color: "#666", borderColor: "#ccc" }}
          >
            {translations[lang].cancel}
          </Button>
          <Button 
            onClick={executeSave} 
            variant="contained" 
            autoFocus
            style={{ textTransform: "none", backgroundColor: "#4763E4", color: "#fff" }}
          >
            {translations[lang].okay}
          </Button>
        </DialogActions>
      </Dialog>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <Button 
            onClick={() => navigate("/gram-sabha-inspection")} 
            variant="outlined" 
            startIcon={<ArrowBackIcon />}
            style={{ textTransform: "none", color: "#4763E4", borderColor: "#4763E4" }}
          >
            {translations[lang].back}
          </Button>
          <h3 style={{ margin: 0, fontWeight: "bold" }}>
            {translations[lang].title}
          </h3>
        </div>
        <Button 
          onClick={() => setLang(lang === "en" ? "hi" : "en")} 
          variant="outlined" 
          style={{ textTransform: "none", color: "#4763E4", borderColor: "#4763E4", fontWeight: "bold" }}
        >
          {translations[lang].langToggle}
        </Button>
      </div>
      <hr style={{ border: "1px solid #ddd", marginBottom: "30px" }} />

      
      {!isFrozen && recordId && (
        <div style={{
          backgroundColor: "#FEF3C7",
          color: "#92400E",
          border: "1px solid #FCD34D",
          padding: "15px",
          borderRadius: "6px",
          marginBottom: "25px",
          fontWeight: "bold",
          fontSize: "14px"
        }}>
          ⚠️ {lang === "en" ? "Note: You can edit this form only one time." : "ध्यान दें: आप इस फॉर्म को केवल एक ही बार एडिट कर सकते हैं।"}
        </div>
      )}

      <form onSubmit={handleSaveClick} style={{ background: "#fff", padding: "30px", borderRadius: "8px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)", width: "100%" }}>
        
        {/* 1. Are all public places clean? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q1}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={publicPlacesClean ? "Yes" : "No"} onChange={(e) => setPublicPlacesClean(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 2. Is door-to-door collection of solid waste being carried out regularly? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q2}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={doorToDoorCollection ? "Yes" : "No"} onChange={(e) => setDoorToDoorCollection(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 3. Is 4-way source segregation practiced? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q3}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={sourceSegregation ? "Yes" : "No"} onChange={(e) => setSourceSegregation(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 4. Is a Solid Waste management shed (SWM Shed) available? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q4}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={swmShedAvailable ? "Yes" : "No"} onChange={(e) => setSwmShedAvailable(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 5. Are public dustbins available and properly maintained? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q5}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={publicDustbinsAvailable ? "Yes" : "No"} onChange={(e) => setPublicDustbinsAvailable(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 6. Are public/community toilets functional, clean, and being regularly maintained? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q6}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={communityToiletsFunctional ? "Yes" : "No"} onChange={(e) => setCommunityToiletsFunctional(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 7. Is there any gap in infrastructure related to solid waste management? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q7}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={infrastructureGap ? "Yes" : "No"} onChange={(e) => setInfrastructureGap(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
          {infrastructureGap && (
            <TextField
              label={translations[lang].infrastructureGapSpecify}
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginTop: "10px" }}
              value={infrastructureGapDetails}
              onChange={(e) => setInfrastructureGapDetails(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.infrastructureGapDetails}
              helperText={formErrors.infrastructureGapDetails}
            />
          )}
        </div>

        {/* 8. Have awareness activities on cleanliness been conducted in the village? */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q8}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={awarenessActivity ? "Yes" : "No"} onChange={(e) => setAwarenessActivity(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 9. Overall Status of Cleanliness & Solid Waste Management */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q9}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={overallStatus} onChange={(e) => setOverallStatus(e.target.value)}>
              <FormControlLabel value="Good" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].good} />
              <FormControlLabel value="Satisfactory" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].satisfactory} />
              <FormControlLabel value="Needs Improvement" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].needsImprovement} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* 10. Total Number of Government Buildings in the Gram Panchayat */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q10}</h5>
          <FormControl size="small" style={{ width: "200px" }}>
            <InputLabel id="gov-total-label">{translations[lang].selectOption}</InputLabel>
            <Select
              labelId="gov-total-label"
              value={govBuildingsTotal}
              label={translations[lang].selectOption}
              onChange={(e) => setGovBuildingsTotal(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.govBuildingsTotal}
            >
              {Array.from({ length: 11 }, (_, i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* 11. Total Number of Government Buildings in Good Condition */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q11}</h5>
          <FormControl size="small" style={{ width: "200px" }}>
            <InputLabel id="gov-good-label">{translations[lang].selectOption}</InputLabel>
            <Select
              labelId="gov-good-label"
              value={govBuildingsGood}
              label={translations[lang].selectOption}
              onChange={(e) => setGovBuildingsGood(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.govBuildingsGood}
            >
              {Array.from({ length: 11 }, (_, i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* 12. Total Number of Government Buildings in satisfactory Condition */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q12}</h5>
          <FormControl size="small" style={{ width: "200px" }}>
            <InputLabel id="gov-satisfactory-label">{translations[lang].selectOption}</InputLabel>
            <Select
              labelId="gov-satisfactory-label"
              value={govBuildingsSatisfactory}
              label={translations[lang].selectOption}
              onChange={(e) => setGovBuildingsSatisfactory(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.govBuildingsSatisfactory}
            >
              {Array.from({ length: 11 }, (_, i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* 13. Total Number of Government Buildings Requiring Repair/Maintenance */}
        <div style={{ marginBottom: "25px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>{translations[lang].q13}</h5>
          <FormControl size="small" style={{ width: "200px" }}>
            <InputLabel id="gov-repair-label">{translations[lang].selectOption}</InputLabel>
            <Select
              labelId="gov-repair-label"
              value={govBuildingsRepairRequired}
              label={translations[lang].selectOption}
              onChange={(e) => setGovBuildingsRepairRequired(e.target.value)}
              disabled={isFrozen}
              error={!!formErrors.govBuildingsRepairRequired}
            >
              {Array.from({ length: 11 }, (_, i) => (
                <MenuItem key={i} value={i}>{i}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* 14. Are all Government Buildings being utilized for their intended purpose? */}
        <div style={{ marginBottom: "35px" }}>
          <h5 style={{ fontWeight: "bold", marginBottom: "5px" }}>{translations[lang].q14}</h5>
          <FormControl component="fieldset">
            <RadioGroup row value={govBuildingsUtilized ? "Yes" : "No"} onChange={(e) => setGovBuildingsUtilized(e.target.value === "Yes")}>
              <FormControlLabel value="Yes" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].yes} />
              <FormControlLabel value="No" control={<Radio color="primary" disabled={isFrozen} />} label={translations[lang].no} />
            </RadioGroup>
          </FormControl>
        </div>

        {/* Submit */}
        <div style={{ display: "flex", gap: "15px", justifyContent: "flex-end", alignItems: "center" }}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => navigate("/gram-sabha-inspection")}
            disabled={saving}
            style={{ textTransform: "none", color: "#666", borderColor: "#ccc" }}
          >
            {translations[lang].cancel}
          </Button>
          {!isFrozen && (
            <Button
              type="submit"
              variant="contained"
              disabled={saving || !isFormValid()}
              style={{ textTransform: "none", backgroundColor: isFormValid() ? "#4763E4" : "#ccc" }}
            >
              {saving ? translations[lang].saving : recordId ? translations[lang].update : translations[lang].save}
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default CleanlinessForm;
